import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    standalone: true,
	imports: [CommonModule, FormsModule],
	selector: 'wd-textarea-modal',
	templateUrl: './textarea-modal.component.html',
	styleUrls: ['../styles/textarea-modal.component.css'],
})
export class TextareaModalComponent {
	@Input() name!: string;
	@Input() label?: string;
	@Input() value = '';
	@Input() readonly = false;

	activeModal = inject(NgbActiveModal);

	onSave() {
		this.activeModal.close(this.value);
	}

	onCancel() {
		this.activeModal.dismiss();
	}
}
